const http = {
  async get<T = any>(
    url: string,
    params?: any,
    options?: RequestInit,
  ): Promise<T> {
    let targetUrl = url;
    if (params) {
      const searchParams = new URLSearchParams(params);
      targetUrl += `?${searchParams.toString()}`;
    }
    return fetch(targetUrl, options).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Request error : ${response.status}`);
    });
  },
  async post<T = any>(
    url: string,
    params?: unknown,
    options?: RequestInit,
  ): Promise<T> {
    const config: RequestInit = {
      ...options,
      method: `post`,
      headers: {
        'Content-Type': `application/json`,
        ...options?.headers,
      },
      body: JSON.stringify(params),
    };
    return fetch(url, config).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Request error : ${response.status}`);
    });
  },
  async put<T = any>(
    url: string,
    params?: unknown,
    options?: RequestInit,
  ): Promise<T> {
    const config: RequestInit = {
      ...options,
      method: `put`,
      headers: {
        'Content-Type': `application/json`,
        ...options?.headers,
      },
      body: JSON.stringify(params),
    };
    return fetch(url, config).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Request error : ${response.status}`);
    });
  },
};

export default http;
